module.exports = __webpack_public_path__ + "static/media/S (69).ef247bf1.jpg";